
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-battery",
      function () {
        return require("private-next-pages/home-battery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-battery"])
      });
    }
  